"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["aria-selected", "href", "target", "tabindex"];
const vue_3 = require("vue");
const use_search_1 = __importStar(require("@/SearchApp/composables/use-search"));
const vue_word_highlighter_1 = __importDefault(require("vue-word-highlighter"));
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const injectionKeys_1 = require("@/SearchApp/constants/injectionKeys");
const core_1 = require("@vueuse/core");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TypeAheadItem',
    props: {
        itemText: {},
        isActive: { type: Boolean },
        href: {},
        target: {}
    },
    setup(__props) {
        const isScreen1408px = (0, core_1.useBreakpoints)({ px1408: "88em" }).greaterOrEqual("px1408");
        // Tabindex -1 on desktop to ensure tab navigation on desktop leads to valid next element instead of a typeAheadItem, which will be hidden at this time.
        const tabIndex = (0, vue_3.computed)(() => (isScreen1408px.value ? -1 : 0));
        const props = __props;
        const typeAheadContainerRef = (0, vue_3.inject)(injectionKeys_1.typeAheadContainerKey, null);
        const { userInput } = (0, use_search_1.default)();
        const typeAheadItemEl = (0, vue_3.useTemplateRef)("typeAheadItemEl");
        const typeAheadId = `typeAhead-${props.itemText.replace(/\s+/g, "-")}`;
        (0, vue_3.watch)(() => props.isActive, (newValue) => {
            if (newValue) {
                use_search_1.focusedTypeAheadId.value = typeAheadId;
                scrollIntoViewIfNeeded();
            }
        });
        const scrollIntoViewIfNeeded = () => {
            if (!typeAheadItemEl.value || !(typeAheadContainerRef === null || typeAheadContainerRef === void 0 ? void 0 : typeAheadContainerRef.value))
                return;
            const rect = typeAheadItemEl.value.getBoundingClientRect();
            const containerRect = typeAheadContainerRef.value.getBoundingClientRect();
            const isVisible = rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;
            if (!isVisible) {
                typeAheadItemEl.value.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                id: typeAheadId,
                ref_key: "typeAheadItemEl",
                ref: typeAheadItemEl,
                role: "option",
                "aria-selected": _ctx.isActive,
                href: _ctx.href,
                target: _ctx.target,
                class: (0, vue_2.normalizeClass)(["-mx-4 flex items-center justify-between px-4 py-3 font-normal hover:bg-gray-20", { 'bg-gray-40': _ctx.isActive }]),
                tabindex: tabIndex.value
            }, [
                (0, vue_2.createVNode)((0, vue_2.unref)(vue_word_highlighter_1.default), {
                    "highlight-style": { fontWeight: 700, background: 'transparent', color: 'inherit' },
                    query: (0, vue_2.unref)(userInput)
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.itemText), 1)
                    ]),
                    _: 1
                }, 8, ["query"]),
                (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                    "icon-name": "arrow-long-thin-right",
                    class: "size-4 shrink-0 text-black-primary"
                })
            ], 10, _hoisted_1));
        };
    }
});
